import { render, staticRenderFns } from "./contentManagement.vue?vue&type=template&id=46bc740e&"
import script from "./contentManagement.vue?vue&type=script&lang=js&"
export * from "./contentManagement.vue?vue&type=script&lang=js&"
import style0 from "./contentManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports